import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Main from 'layouts/Main';
import Container from 'components/Container';
import { useTranslation } from 'react-i18next';

const Section = ({ title, content }) => (
  <Box mb={4}>
    <Typography variant="h6" component="h2" gutterBottom>
      {title}
    </Typography>
    <Typography variant="body1" paragraph>
      {content}
    </Typography>
  </Box>
);

const CookiePolicy = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Main>
      <Container>
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            {t('cookiePolicy.title')}
          </Typography>
          <Typography variant="body1" paragraph mb={4}>
            {t('cookiePolicy.subText')}
          </Typography>
          <Section 
            title={t('cookiePolicy.whatAreCookies')}
            content={t('cookiePolicy.whatAreCookiesSubText')}
          />
          <Section 
            title={t('cookiePolicy.howWeUseCookies')}
            content={t('cookiePolicy.howWeUseCookiesSubText')}
          />
          <Section 
            title={t('cookiePolicy.typesOfCookies')}
            content={t('cookiePolicy.typesOfCookiesSubText')}
          />
          <Section 
            title={t('cookiePolicy.essentialCookies')}
            content={t('cookiePolicy.essentialCookiesSubText')}
          />
          <Section 
            title={t('cookiePolicy.analyticsCookies')}
            content={t('cookiePolicy.analyticsCookiesSubText')}
          />
          <Section 
            title={t('cookiePolicy.marketingCookies')}
            content={t('cookiePolicy.marketingCookiesSubText')}
          />
          <Section 
            title={t('cookiePolicy.thirdPartyCookies')}
            content={t('cookiePolicy.thirdPartyCookiesSubText')}
          />
          <Section 
            title={t('cookiePolicy.managingCookies')}
            content={t('cookiePolicy.managingCookiesSubText')}
          />
          <Section 
            title={t('cookiePolicy.updatesToPolicy')}
            content={t('cookiePolicy.updatesToPolicySubText')}
          />
          <Section 
            title={t('cookiePolicy.contactUs')}
            content={t('cookiePolicy.contactUsSubText')}
          />
        </Box>
      </Container>
    </Main>
  );
};

export default CookiePolicy; 